module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_vm._v("  :: Acesso não autorizado ::  ")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34015541"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SemPermissao.vue
// module id = 283
// module chunks = 1